export const iconFontAwesomeUsersPeopleIdBadge = (
	<i className="fa-solid fa-id-badge"></i>
);
